import { useEffect, useRef } from "react";
import { useTheme } from "@mui/material";
import { useMap } from "@vis.gl/react-google-maps";
import { MapRouteProps } from "./map";

interface PolylineProps {
    route: MapRouteProps;
    onClick?: (dataId: string) => void;
}

export const Polyline = ({ route, onClick }: PolylineProps) => {
    const theme = useTheme();
    const map = useMap();

    const { coords, color, highlight } = route;
    const polylineRef = useRef<google.maps.Polyline | null>(null);

    useEffect(() => {
        if (!map) return;

        polylineRef.current = new google.maps.Polyline({
            path: coords,
            strokeColor: route.strokeColor ?? (highlight
                ? theme.palette.error.main
                : color ?? theme.palette.primary.main),
            strokeWeight: route.strokeWeight ?? (highlight ? 5 : 3),
            zIndex: route.zIndex ?? null,
            strokeOpacity: route.strokeOpacity ?? null,
        });

        polylineRef.current?.setMap(map);

        if (onClick) {
            polylineRef.current.addListener("click", () => {
                onClick(route.dataId);
            });
        }

        return () => {
            polylineRef.current?.setMap(null);
        };
    }, [map, coords, color, highlight]);

    return null;
};
